<template>
  <div class="classList">
    <div class="content">
      <el-row>
        <el-button
          type="primary"
          round
          @click="(addSortCon = true), (makeBtnStatus = true)"
          >添加分类</el-button
        >
      </el-row>
      <el-table
        border
        row-key="id"
        :data="tableData"
        v-loading="loading"
        default-expand-all
        element-loading-text="拼命加载中"
        style="width: 100%;margin-bottom: 20px;margin-top: 20px"
        :tree-props="{ children: 'children', hasChildren: 'child' }"
      >
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column>-->
        <el-table-column
          prop="sort"
          label="排序"
          sortable
          width="180"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          sortable
          width="180"
        ></el-table-column>
        <el-table-column prop="des" label="描述"></el-table-column>
        <el-table-column prop="adv_link" label="广告链接"></el-table-column>
        <!-- <el-table-column
          prop="search_group_ids"
          label="筛选项">
          <template slot-scope="scope">
            <span v-for="(item, idx) in scope.row.search_group_ids" :key="idx">
              {{item}}
            </span>
          </template>
        </el-table-column>-->
        <el-table-column prop="status" label="是否显示">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status == 1 ? 'success' : 'danger'"
              effect="dark"
              >{{ scope.row.status == 1 ? "是" : "否" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="
                (addSortCon = true),
                  (nowParent_id = scope.row.id),
                  (makeBtnStatus = true)
              "
              >添加</el-button
            >
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加分类" :visible.sync="addSortCon">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input
            type="number"
            min="0"
            v-model="form.sort"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="name"
          label="分类名称"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="name" label="封面图" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="是否热门" :label-width="formLabelWidth">
          <el-radio v-model="form.status" label="1">是</el-radio>
          <el-radio v-model="form.status" label="2">否</el-radio>
        </el-form-item>
        <el-form-item label="是否显示" :label-width="formLabelWidth">
          <el-radio v-model="form.status" label="1">显示</el-radio>
          <el-radio v-model="form.status" label="2">隐藏</el-radio>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="form.des"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addSortCon = false">取 消</el-button>

        <el-button
          v-if="makeBtnStatus"
          type="primary"
          @click="make_con('ruleForm')"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="edit_con('ruleForm')"
          >修 改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  getShopGoodsList,
  deleteShopSorts,
  addShopSorts,
  editShopSorts,
  getDeatil,
  getGoodscate
} from "@/api/mall";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  watch: {
    // 判断当前是修改状态还是添加状态
    makeBtnStatus: function(val) {
      if (val) {
        this.brandArr = [];
        this.form = {
          // 表单内容
          name: "",
          parent_id: 0,
          image_id: "",
          adv_link: "",
          des: "",
          status: "1",
          brand: {
            name: [],
            logo: [],
            sort: []
          },
          param: {
            name: []
          }
        };
      }
    }
  },
  data() {
    const generateData = _ => {
      const data = [];
      const cities = ["上海", "北京", "广州", "深圳", "南京", "西安", "成都"];
      const pinyin = [
        "shanghai",
        "beijing",
        "guangzhou",
        "shenzhen",
        "nanjing",
        "xian",
        "chengdu"
      ];
      cities.forEach((city, index) => {
        data.push({
          label: city,
          key: index,
          pinyin: pinyin[index]
        });
      });
      return data;
    };
    return {
      screendata: generateData(),
      value: [],

      multipleSelection: [],
      tableData: [], // 分类数据
      addSortCon: false, // 添加分类内容状态
      brandStatus: false, // 添加品牌内容状态
      formLabelWidth: "140px",
      inputVisible: false,
      inputValue: "",

      makeBtnStatus: true,

      updatetId: "", //更新使用id

      nowParent_id: "",
      imgdata: {},
      loading: true,
      imageUrl: "", // 广告上传
      logoUrl: "", // 当前品牌logo上传

      brandArr: [],
      brandItem: {
        name: "",
        logo: "",
        sort: ""
      },
      detailObj: {},
      form: {
        // 表单内容
        name: "",
        parent_id: 0,
        image_id: "",
        adv_link: "",
        des: "",
        status: "1"
      },
      rules: {
        name: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 获取筛选项列表
    getScreenList() {
      getGoodscate({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 1) {
          this.screendata = res.data;
        }
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 获取分类层级
    getAllLevel() {
      // 获取分类层级
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      getShopGoodsList(data).then(res => {
        console.log(res);
        if (res.code == 1) {
          if (res.data.length > 0) {
            this.tableData = res.data;
          } else {
          }
        } else {
          this.$message(res.msg);
        }
      });
    },

    // 穿梭框数据
    handleChange(value, direction, movedKeys) {
      this.value = value;
    },
    // 提交表单
    make_con(formName, item) {
      console.log(this.form);
      this.form.token = this.token;
      this.form.app_id = this.app_id;
      if (this.nowParent_id) {
        this.form.parent_id = this.nowParent_id;
      }
      console.log(this.value);
      this.form.search_group_ids = this.value.join(",");
      this.$refs[formName].validate(valid => {
        if (valid) {
          addShopSorts(this.form).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              // 更新表格
              this.getAllLevel();
              this.addSortCon = false;
            } else {
              this.$message.danger(res.msg);
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除分类
    handleDelete(index, item) {
      this.$confirm("确认删除该分类？")
        .then(_ => {
          deleteShopSorts({
            token: this.token,
            app_id: this.app_id,
            id: item.id
          }).then(res => {
            this.$message(res.msg);
            // 更新表格
            this.getAllLevel();
          });
          done();
        })
        .catch(_ => {});
    },
    // 获取分类详细信息
    handleEdit(idx, item) {
      this.makeBtnStatus = false;
      this.updatetId = item.id;
      getDeatil({ token: this.token, app_id: this.app_id, id: item.id }).then(
        res => {
          if (res.code == 1) {
            const {
              adv_link,
              des,
              parent_id,
              sort,
              name,
              status,
              brand,
              params
            } = res.data;
            // 赋值
            this.form = {
              name,
              parent_id,
              adv_link,
              des,
              status: status.toString(),
              sort
            };
            this.addSortCon = true;
            // 穿梭框渲染
            var arr = res.data;
            var newvalue = arr.search_group_ids.split(",");
            newvalue.forEach(element => {
              this.value.push(element * 1);
            });
          }
        }
      );
    },
    // 修改分类信息
    edit_con(val) {
      this.form.token = this.token;
      this.form.app_id = this.app_id;
      this.form.id = this.updatetId;
      if (this.value.length > 0) {
        this.form.search_group_ids = this.value.join(",");
      } else {
        this.form.search_group_ids = "";
      }
      this.$refs[val].validate(valid => {
        if (valid) {
          editShopSorts(this.form).then(res => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              // 更新表格
              this.getAllLevel();
              this.addSortCon = false;
            } else {
              this.$message.danger(res.msg);
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    adLogoSuccess(res, file) {
      this.$message(res.msg);
      if (res.code == 1) {
        this.brandItem.logo = res.data.id;
      }
      this.logoUrl = URL.createObjectURL(file.raw);
    },
    // 上传图片
    handleLogoSuccess(res, file) {
      console.log(res);
      this.$message(res.msg);
      if (res.code == 200) {
        this.form.image_id = res.data.id;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.imgdata = {
        app_id: this.app_id,
        token: this.token,
        type: "1",
        file_group: "1"
      };
      this.getAllLevel();
      this.getScreenList();
      setTimeout(() => {
        this.loading = false;
      }, 800);
    });
  }
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #8c939d !important;
}
.avatar {
  width: 350px;
  height: 140px;
  display: block;
}
.avatar1 {
  width: 60px;
  height: 60px;
  display: block;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.brand-con {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.classList {
  width: 100%;
  height: 100%;
  position: relative;
  .cursor {
    cursor: pointer;
  }
  .content {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
    margin: 0 auto;
    border-radius: 3px;
    padding: 30px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  }
}
</style>
